import { doc, setDoc, deleteDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const getSharedBoardDoc = () => doc(db, 'smm_shared_data', 'kanban');

// Real-time: tasks o'zgarishlarini kuzatish
export const onKanbanTasksChange = (callback) => {
  return onSnapshot(
    getSharedBoardDoc(),
    (snapshot) => {
      const data = snapshot.data();
      callback(data?.tasks ?? null, null);
    },
    (err) => callback(null, err)
  );
};

// Tasks'ni Firestore'ga saqlash
export const updateKanbanTasks = async (tasks) => {
  await setDoc(getSharedBoardDoc(), { tasks }, { merge: true });
};

// Real-time: archives o'zgarishlarini kuzatish
export const onKanbanArchivesChange = (callback) => {
  return onSnapshot(
    getSharedBoardDoc(),
    (snapshot) => {
      const data = snapshot.data();
      callback(data?.archives ?? null, null);
    },
    (err) => callback(null, err)
  );
};

// Archives'ni Firestore'ga saqlash
export const updateKanbanArchives = async (archives) => {
  await setDoc(getSharedBoardDoc(), { archives }, { merge: true });
};

// Foydalanuvchiga xos shablonlar
export const onKanbanTemplatesChange = (callback) => {
  return onSnapshot(
    getSharedBoardDoc(),
    (snapshot) => {
      const data = snapshot.data();
      callback(Array.isArray(data?.templates) ? data.templates : null, null);
    },
    (err) => callback(null, err)
  );
};

export const updateKanbanTemplates = async (templates) => {
  await setDoc(getSharedBoardDoc(), { templates: Array.isArray(templates) ? templates : [] }, { merge: true });
};

// Barcha Kanban ma'lumotlarini o'chirish
export const clearAllKanbanData = async () => {
  await deleteDoc(getSharedBoardDoc());
};
